import React from "react";
import _ from "lodash";

export default class ImageViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: ""
    };
  }

  componentWillReceiveProps = e => {
    this.setState({
      selected: e.images[0]
    });
  };

  handleSelectChange = image => {
    this.setState({
      selected: image
    });
  };

  render() {
    var selected = this.state.selected
      ? this.state.selected
      : this.props.images[0];
    var images = this.props.images.filter(i => !!i);
    return (
      <div className="imageviewer">
        <div className="imageviewer__large">
          <img alt="" src={selected} />
        </div>
        {images.length > 1 && (
          <div className="imageviewer__small">
            {_.map(images, (image, key) => {
              return (
                <img
                  key={key}
                  onClick={this.handleSelectChange.bind(this, image)}
                  alt=""
                  src={image}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/ImageViewer.jsx